// src\pages\NewsDetail.jsx お知らせnews詳細ページ

import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Breadcrumb from "../components/Breadcrumb";

const NewsDetail = () => {
  const { id } = useParams();
  const [newsItem, setNewsItem] = useState(null);

  useEffect(() => {
    if (!id) return;
    fetch(`/api/public/news/${id}`)
      .then((res) => res.json())
      .then(setNewsItem)
      .catch((err) => {
        console.error("お知らせ詳細の取得に失敗:", err);
        setNewsItem(null);
      });
  }, [id]);

  if (!newsItem) {
    return <div className="text-center py-16">読み込み中...</div>;
  }

  return (
    <>
      <Breadcrumb extra={newsItem.title} />

      <div className="max-w-3xl mx-auto p-4">
        <p className="text-sm text-gray-500 mb-2">
          {new Date(newsItem.createdAt).toLocaleDateString("ja-JP", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </p>
        <h1 className="text-2xl font-bold mb-4">{newsItem.title}</h1>
        <p className="whitespace-pre-wrap mb-4">{newsItem.body}</p>
        {newsItem.image && (
          <img src={newsItem.image} alt="お知らせ画像" className="mb-6 max-w-full" />
        )}
        <Link to="/news" className="text-blue-600 underline">
          ← お知らせ一覧に戻る
        </Link>
      </div>
    </>
  );
};

export default NewsDetail;
